import React from 'react'

const lineFeedRegex = /([\n])/g
export function nl2br(str) {
  return str.split(lineFeedRegex).map((line, i) => {
    // eslint-disable-next-line react/no-array-index-key
    const newLine = line.match(lineFeedRegex) ? <br key={i} /> : line
    return newLine
  })
}
